
<template>
  <div class="headline text-center">
    Olá <b>{{user_name}}</b>, boas-vindas ao sistema de cadastros e financeiro!
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      profile_d: {
        name: 'Usuário de testes'
      }
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    user_name() {
      return this.profile.data?.attributes?.name || ''
    },
    ...mapState({
      profile: state=>state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>